// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useState, useContext} from 'react';
import cn from 'classnames';
import {Trans as T, useTranslation} from 'react-i18next';
import {useHistory} from 'react-router';
import zutil from '/util/util.js';
// @ts-ignore
import {get_exe_link} from '../install_util.js';
// @ts-ignore
import {App_context} from '../context.js';
// @ts-ignore
import {ga_track_download_send} from '../ga.js';
// @ts-ignore
import zurl from '/util/url.js';
import {Link as RRD_link} from 'react-router-dom';
import {img_url} from './img_url';
import {Svg} from './svg';
import './platform_buttons.module.less';
import {use_client_hints} from '../client_hints';
import Icon_windows from '../img/svg/pl/ic-windows.svg';
import Icon_mac from '../img/svg/pl/ic-mac.svg';
import Icon_android from '../img/svg/pl/ic-android.svg';
import Icon_ios from '../img/svg/pl/ic-ios.svg';
import Icon_smarttv from '../img/svg/pl/ic-smarttv.svg';
import Icon_console from '../img/svg/pl/ic-console.svg';
import Icon_router from '../img/svg/pl/ic-router.svg';
import Icon_ie from '../img/svg/pl/ic-ie.svg';
import Icon_edge from '../img/svg/pl/ic-edge.svg';
import Icon_chrome from '../img/svg/pl/ic-chrome.svg';
import Icon_opera from '../img/svg/pl/ic-opera.svg';
import Icon_windows_active from '../img/svg/pl/ic-windows-active.svg';
import Icon_mac_active from '../img/svg/pl/ic-mac-active.svg';
import Icon_android_active from '../img/svg/pl/ic-android-active.svg';
import Icon_ios_active from '../img/svg/pl/ic-ios-active.svg';
import Icon_smarttv_active from '../img/svg/pl/ic-smarttv-active.svg';
import Icon_console_active from '../img/svg/pl/ic-console-active.svg';
import Icon_router_active from '../img/svg/pl/ic-router-active.svg';
import Icon_ie_active from '../img/svg/pl/ic-ie-active.svg';
import Icon_edge_active from '../img/svg/pl/ic-edge-active.svg';
import Icon_chrome_active from '../img/svg/pl/ic-chrome-active.svg';
import Icon_opera_active from '../img/svg/pl/ic-opera-active.svg';
import Icon_mac_beta_active from '../img/svg/pl/ic-mac-active.svg';
import Icon_firetv_active from '../img/svg/pl/ic-firetv-active.svg';
import Icon_lg_active from '../img/svg/pl/ic-lg-active.svg';
import Icon_huawei_active from '../img/svg/pl/ic-huawei-active.svg';
import Icon_samsung_active from '../img/svg/pl/ic-samsung-active.svg';
import Icon_appletv_active from '../img/svg/pl/ic-appletv-active.svg';
import Icon_playstation_active from '../img/svg/pl/ic-playstation-active.svg';
import Icon_xbox_active from '../img/svg/pl/ic-xbox-active.svg';

const ic_props = {width: 32, height: 32, preserve_aspect_ratio: 'xMinYMin'};
const svg_icons = {
    'ic-windows': <Icon_windows {...ic_props}/>,
    'ic-mac': <Icon_mac {...ic_props}/>,
    'ic-android': <Icon_android {...ic_props}/>,
    'ic-ios': <Icon_ios {...ic_props}/>,
    'ic-smarttv': <Icon_smarttv {...ic_props}/>,
    'ic-console': <Icon_console {...ic_props}/>,
    'ic-router': <Icon_router {...ic_props}/>,
    'ic-ie': <Icon_ie {...ic_props}/>,
    'ic-edge': <Icon_edge {...ic_props}/>,
    'ic-chrome': <Icon_chrome {...ic_props}/>,
    'ic-opera': <Icon_opera {...ic_props}/>,
    'ic-windows-active': <Icon_windows_active {...ic_props}/>,
    'ic-mac-active': <Icon_mac_active {...ic_props}/>,
    'ic-android-active': <Icon_android_active {...ic_props}/>,
    'ic-ios-active': <Icon_ios_active {...ic_props}/>,
    'ic-smarttv-active': <Icon_smarttv_active {...ic_props}/>,
    'ic-console-active': <Icon_console_active {...ic_props}/>,
    'ic-router-active': <Icon_router_active {...ic_props}/>,
    'ic-ie-active': <Icon_ie_active {...ic_props}/>,
    'ic-edge-active': <Icon_edge_active {...ic_props}/>,
    'ic-chrome-active': <Icon_chrome_active {...ic_props}/>,
    'ic-opera-active': <Icon_opera_active {...ic_props}/>,
    'ic-mac_beta-active': <Icon_mac_beta_active {...ic_props}/>,
    'ic-firetv-active': <Icon_firetv_active {...ic_props}/>,
    'ic-lg-active': <Icon_lg_active {...ic_props}/>,
    'ic-huawei-active': <Icon_huawei_active {...ic_props}/>,
    'ic-samsung-active': <Icon_samsung_active {...ic_props}/>,
    'ic-appletv-active': <Icon_appletv_active {...ic_props}/>,
    'ic-playstation-active': <Icon_playstation_active {...ic_props}/>,
    'ic-xbox-active': <Icon_xbox_active {...ic_props}/>,
};

const pl_images = {
    'browser-active': 'ic_browser',
    'adblock-active': 'ic_adblocker',
    'gps-active': 'ic_gps',
    'luminati-active': 'ic_brightdata',
    browser: 'ic_browser_gray_16',
    adblock: 'ic_adblocker_gray_16',
    gps: 'ic_gps_gray_16',
    luminati: 'ic_brightdata_gray',
};

const Platform_icon = ({size, name})=>{
    if (pl_images[name])
    {
        return <img width={size} height={size} className="lazyload"
          src={img_url(`/platforms/${pl_images[name]}.svg`)} alt="platforms"/>;
    }
    const id = `ic-${name}`;
    return <Svg icon={svg_icons[id]}/>;
};

interface i_premium_opt {
    href?: string;
}

interface i_platform_opt extends i_premium_opt {
    name?: string;
}

interface i_platform_href_props {
    is_paid: boolean;
    premium?: i_premium_opt;
    platform: i_platform_opt;
}

const get_platform_href = ({premium, platform, is_paid}
    : i_platform_href_props)=>{
    if (is_paid)
    {
        return premium ? premium.href : '/plus_setup?platform='
             + platform.name;
    }
    if (platform.href)
        return platform.href;
    return '/premium?ref='+platform.name;
};

export interface i_platform {
    name: string;
    href: string;
    title: string;
    rel?: string;
    tooltip_pos?: string;
    versions_text?: string;
    versions?: any;
    install_href?: string;
    store?: string;
    order?: number;
}

interface i_platform_button_props {
    platform: i_platform;
    is_active: boolean;
    set_active: (name: string|null)=>void;
    root_ref: React.RefObject<HTMLDivElement>;
    always_colored?: boolean;
    download?: boolean;
    is_selected: boolean;
    tooltip: boolean;
    key?: any;
}

const get_link = (platform_name: string, platform: i_platform,
    download: boolean, win_mac_link: (platform_key: string)=>string)
    : string=>
{
    const simple_href_platforms = ['console', 'ie', 'edge', 'firefox',
        'opera', 'ios', 'huawei', 'samsung'];
    if (['mac_beta', 'mac', 'windows'].indexOf(platform_name) >= 0)
        return win_mac_link(platform_name=='windows' ? 'windows' : 'macos');
    if (!download || simple_href_platforms.indexOf(platform_name) >= 0)
        return platform.href;
    return `/download/${platform_name}`;
};

interface i_platform_link_attrs_props {
    platform: i_platform;
    download?: boolean;
}

export const get_platform_link_attrs = ({platform, download = true}
    : i_platform_link_attrs_props)=>{
    const history = useHistory();
    // @ts-ignore
    const {has_svc, svc_info, is_client} = useContext(App_context);
    use_client_hints();
    const platform_name = {windows10: 'windows'}[platform.name]
        || platform.name;
    const link = is_client || platform_name!='windows' ?
        get_link(platform_name, platform, download,
            platform_key=>get_exe_link({has_svc, svc_info, os: platform_key})
        ) : '/download';
    return {
        to: link,
        onClick: ()=>{
            if (['mac', 'mac_beta', 'windows'].indexOf(platform_name) >= 0)
            {
                ga_track_download_send(platform_name=='windows' ? 'exe'
                    : 'dmg', 'homepage', link, null, undefined, {});
                history.push(location.pathname+'?flow=full&step=install&os='+
                    (platform_name=='windows' ? 'windows' : 'macos'));
            }
        },
        'data-clickid': `platform_btn_${platform_name}`
    };
};

const Link = props=>{
    const href = props.to || props.href;
    const is_external = !!zurl.parse(href).host;
    const {children, ...other} = props;
    if (is_external)
        return <a href={href} {...other}>{children}</a>;
    return <RRD_link to={href} {...other}>{children}</RRD_link>;
};

const Platform_button = ({platform, is_active, set_active, root_ref, tooltip,
    is_selected, download = true, always_colored = false}
    : i_platform_button_props)=>{
    const ic_cls = cn('platform-icon', (is_active || is_selected) && 'active');
    const [show_up, set_show_up] = useState(true);
    const on_mouse_enter = ()=>{
        const offset = root_ref.current.getBoundingClientRect().y;
        if (show_up && offset < 156)
            set_show_up(false);
        if (!show_up && offset >= 156)
            set_show_up(true);
        set_active(platform.name);
    };
    const tip_cls = cn('platform-tooltip', show_up && 'up');
    const name = `${platform.name}${always_colored ? '-active' : ''}`;
    const name_active = `${platform.name}-active`;
    const link_attrs = get_platform_link_attrs({platform, download});
    return <Link className="platform-button" onMouseEnter={on_mouse_enter}
      onMouseLeave={()=>set_active(null)} {...link_attrs}>
      <div className={ic_cls}>
        <Platform_icon size="32" name={name}/>
        <Platform_icon size="32" name={name_active}/>
      </div>
      {!tooltip && <div className="platform-title">{platform.title}</div>}
      {tooltip && is_active &&
        <div className={tip_cls}>{platform.title}</div>}
    </Link>;
};

export type t_interface_type = 'one-line'|'wide-item'|'cards';

interface i_platform_buttons_props {
    platforms: i_platform[];
    premium_setup: any;
    is_paid?: boolean;
    selected?: string | null;
    type?: t_interface_type;
    tooltip?: boolean;
    title?: string;
    square?: boolean;
    download?: boolean;
}

export const Platform_buttons = ({platforms, premium_setup, is_paid=false,
    selected=null, type='one-line', tooltip=false, title, square=false,
    download=false} : i_platform_buttons_props)=>{
    const [active, set_active] = useState(null);
    const root_ref = React.createRef<HTMLDivElement>();
    useTranslation();
    const cls_full = cn('platform-buttons', `type-${type}`, {square});
    return <div className={cls_full} ref={root_ref}>
      {platforms.map(platform=>{
          const is_active = platform.name==active;
          const is_selected = platform.name==selected;
          const premium = zutil.find_prop(premium_setup, 'name',
              platform.name);
          platform.href = get_platform_href({premium, platform, is_paid});
          return <Platform_button platform={platform} set_active={set_active}
            is_active={is_active} key={platform.name} is_selected={is_selected}
            root_ref={root_ref}
            always_colored={type=='wide-item'} download={download}
            tooltip={tooltip || ['one-line', 'cards'].indexOf(type) >= 0}/>;
      })}
      {type=='wide-item' && Array(4).fill(0).map((el, i)=><i key={i}></i>)}
      {title && <div className="title"><T>{title}</T></div>}
    </div>;
};
